module.exports = __webpack_public_path__ + "media/images/landing/we_believe_2-28ea3bb073793ec84de000184347fb9d.png";